// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "460" ? "quickjs-sandbox" : chunkId) + "." + {"396": "3c427feee48ff8e8","460": "3d911e78ba3fe5a8","917": "46684ca73df5ab6e","985": "f77a13f6ffc3e791",}[chunkId] + ".chunk.js"
}